import { useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Logo } from "@/components/site/Logo";
import api, { formatApiError } from "@/lib/api";
import { toast } from "sonner";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const token = params.get("token");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post("/auth/reset-password", { token, password });
      toast.success("Password updated. Please sign in.");
      navigate("/admin/login");
    } catch (err) { toast.error(formatApiError(err.response?.data?.detail)); }
    finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#F9FAFB] p-8">
      <div className="w-full max-w-sm bg-white rounded-2xl border border-border p-8">
        <Logo className="text-2xl" />
        <h1 className="mt-6 font-display text-2xl font-bold text-[#111827]">Set a new password</h1>
        {!token ? (
          <p className="mt-4 text-sm text-red-600">Missing or invalid reset token.</p>
        ) : (
          <form onSubmit={submit} className="mt-6 space-y-4">
            <div className="space-y-1.5"><Label>New password</Label><Input type="password" required minLength={8} value={password} onChange={(e) => setPassword(e.target.value)} data-testid="reset-password" /></div>
            <Button type="submit" disabled={busy} className="w-full h-11 rounded-full bg-[#C81D35] hover:bg-[#a5162b]" data-testid="reset-submit">{busy ? "Saving..." : "Update password"}</Button>
          </form>
        )}
      </div>
    </div>
  );
}
